import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from './sub_components/toast';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as UserSettlementService from '../services/userSettlementService'
import Currency from './sub_components/currency'
import { BASE_IMAGE_PATH } from '../configs/api';
let typeUserPnlTimeout
class MasterSettlement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uid: "",
            passcode: "",
            masterPassword: "",
            allRemarks: "",
            settlementData: [],
            typeUserPnl: [],
            toastMsg: "",
            toastType: ""
        };
    }
    async componentDidMount() {
        this.onGetSettelment()
    }
    componentWillUnmount(){
        clearTimeout(typeUserPnlTimeout)
    }
    async onGetSettelment() {
        let stl_data = await UserSettlementService.getMasterSettlement()
        let settlement = []
        for (let stl of stl_data) {
            if (stl["pnl"] === null) {
                stl["pnl"] = 0
            }
            else if (stl["pnl"] > 0) {
                let tot = stl.balance + stl.exposure
                if (tot >= 0) {
                    stl["current_pnl"] = stl.pnl
                } else if (tot + stl.pnl < 0) {
                    stl["current_pnl"] = 0;
                }
                else {
                    stl["current_pnl"] = tot + stl.pnl;
                }
            }
            else {
                stl["current_pnl"] = stl.pnl
            }
            stl["pnl"] = 0
            settlement.push(stl)
        }
        this.setState({ settlementData: settlement, masterPassword: "" })
    }

    onAmountChange(e, i, settlement) {
        const name = e.target.name;
        const value = e.target.value;
        let stl_data = this.state.settlementData
        if (name === "pnl") {
            stl_data[i][name] = Math.abs(parseFloat(value).toFixed(2))
        }
        else {
            stl_data[i][name] = value
        }
        this.setState({ settlementData: stl_data })
    }
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }
    async onSubmit() {
        if (this.state.masterPassword === "") {
            this.props.notify("Master password is not set", "error")
            return false
        }
        let typeUserPnl = []
        let settlementData = []
        // for (let stl of this.state.settlementData) {
        //     if (parseFloat(parseFloat(Math.abs(stl["pnl"])).toFixed(2)) > parseFloat(parseFloat(Math.abs(stl["current_pnl"])).toFixed(2))) {
        //         typeUserPnl.push(stl.username)
        //     }
        //     if(parseFloat(parseFloat(Math.abs(stl["pnl"])).toFixed(2)) === parseFloat(parseFloat(Math.abs(stl["current_pnl"])).toFixed(2))){
        //         stl["pnl"] = Math.abs(stl["current_pnl"])
        //         settlementData.push(stl)
        //     }else{
        //         stl["pnl"] = Math.abs(stl["pnl"])
        //         settlementData.push(stl)
        //     }
        // }
        for (let stl of this.state.settlementData) {
            if (Math.round(Math.abs(stl["pnl"]) * 100) / 100 > Math.round(Math.abs(stl["current_pnl"]) * 100) / 100) {
                typeUserPnl.push(stl.username)
            }
            if (Math.round(Math.abs(stl["pnl"]) * 100) / 100 === Math.round(Math.abs(stl["current_pnl"]) * 100) / 100) {
                stl["pnl"] = Math.round(Math.abs(stl["current_pnl"]) * 100) / 100
                if (stl["pnl"] > 0) {
                    settlementData.push(stl)
                }
            } else {
                stl["pnl"] = Math.round(Math.abs(stl["pnl"]) * 100) / 100
                if (stl["pnl"] > 0) {
                    settlementData.push(stl)
                }
            }
        }
        if (typeUserPnl.length > 0) {
            this.props.notify("Settle Amount should not more than Client(P/L)", "error")
            this.setState({ typeUserPnl: typeUserPnl }, () => {
                setTimeout(() => {
                    this.setState({ typeUserPnl: [] })
                }, 10000)
            })
        } else {
            let body = {
                "masterPassword": this.state.masterPassword,
                "settlements": !!settlementData ? settlementData : []
            }
            body = this.clean(body);
            await UserSettlementService.postMasterSettlement(body).then((res) => {
                if (res.isSuccess) {
                    this.props.notify("Settlement Successfully Done", "success");
                    this.onGetSettelment()
                }
                else {
                    this.props.notify(res.exception.message, "error")
                }
            })
        }
    }
    handleKey(e) {
        if (e.keyCode === 13) {
            this.onSubmit();
        }
    }
    onSettleClear() {
        let settlement = []
        for (let stl of this.state.settlementData) {
            stl["pnl"] = 0
            stl["description"] = ""
            settlement.push(stl)
        }
        this.setState({ settlementData: settlement, typeUserPnl: [], allRemarks: "", masterPassword: "" })
    }
    onSettleAll() {
        let settlement = []
        for (let stl of this.state.settlementData) {
            if (stl["current_pnl"] !== 0) {
                stl["pnl"] = Math.abs(stl["current_pnl"]).toFixed(2)
                stl["description"] = this.state.allRemarks
                settlement.push(stl)
            }
            else {
                stl["pnl"] = 0
                stl["description"] = ""
                settlement.push(stl)
            }
        }
        this.setState({ settlementData: settlement, typeUserPnl: [] })
    }
    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }
    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value })
    }
    render() {
        let plus_data = this.state.settlementData.filter((stl) => { return stl.current_pnl >= 0 })
        let minus_data = this.state.settlementData.filter((stl) => { return stl.current_pnl < 0 })
        return (
            <div className="bethubs">
                <Header history = {this.props.history} />
                <div className="wrapper mb30">
                    <div className="container-fluid container-padding-0">
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="main-box">
                                    <h5 className="text-blue">Master Settlement</h5>
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 mb-2 ">
                                            <div className=" sports-tabel">
                                                <table className={plus_data.length > 0 ? "table table-responsive table-bordered tableprofit table-sm addpadding w-100" : "table table-responsive table-bordered tableprofit table-sm addpadding w-100 responsivetbl"}>
                                                    <thead>
                                                        <tr className="tbg">
                                                            <th className="font-weight-bold " colSpan="6">Creditors Account (dena hai)</th>
                                                        </tr>
                                                        <tr className="headings plusacc">
                                                            <th className="font-weight-bold width-150">Account</th>
                                                            <th className="font-weight-bold width-100 text-right">Client(P/L)</th>
                                                            <th className="font-weight-bold width-130 text-right">Short Balance</th>
                                                            <th className="font-weight-bold width-130" colSpan="2">Settle Amount</th>
                                                            <th className="font-weight-bold ">Remarks</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {!!this.state.settlementData && this.state.settlementData.map((settlement, i) => {
                                                            const requiredBalancechk = !!settlement.requiredBalance ? (settlement.requiredBalance - settlement.balance) : 0;
                                                            return (<>
                                                                {settlement.current_pnl >= 1 &&
                                                                    <tr className={this.state.typeUserPnl.length > 0 ? this.state.typeUserPnl.includes(settlement.username) ? "error-alert plusacc" : "plusacc" : "plusacc"}>
                                                                        <td className="width-150" style={{ verticalAlign: "middle" }}><div className="res"><span className={settlement.role === "SuperMaster" || settlement.role === "SubSuperMaster" ? "client-icon-sm" : "client-icon"}><img src={BASE_IMAGE_PATH + "../images/" + settlement.role + "-icon.svg"} alt="" /></span>{settlement.username} </div></td>
                                                                        <td className="width-100 green text-right width-100 res" style={{ verticalAlign: "middle" }} >{!!settlement.current_pnl ? <Currency amount={settlement.current_pnl} showColor={true} /> : "0"}</td>
                                                                        <td className="width-100 text-right width-100 res" style={{ verticalAlign: "middle" }} >{requiredBalancechk < 0 ? '0' : <Currency amount={requiredBalancechk} showColor={false} /> }</td>
                                                                        <td className="green width-130">
                                                                            <div className="d-flex res"><input type="number" name="pnl" value={settlement.pnl} onChange={(e) => { this.onAmountChange(e, i, settlement) }} className="form-control mobilewidth" placeholder="" />
                                                                            </div>
                                                                        </td>
                                                                        <td className="width-80 mx-auto"><div className="res1"><button className="btn btn-green btn-sm ml-1 float-right" onClick={(e) => { e.target.name = "pnl"; e.target.value = settlement.current_pnl; this.onAmountChange(e, i) }}>Full Settle</button></div></td>
                                                                        <td className="width-90">
                                                                            <input type="text" name="description" value={settlement.description} onChange={(e) => { this.onAmountChange(e, i, settlement) }} className="form-control w-100 mobilewidth" placeholder="Remarks" />
                                                                        </td>
                                                                    </tr>
                                                                }
                                                            </>)
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 mb-2 ">
                                            <div className=" sports-tabel">
                                                <table className={minus_data.length > 0 ? "table table-responsive table-bordered tableprofit table-sm addpadding w-100" : "table table-responsive table-bordered tableprofit table-sm addpadding w-100 responsivetbl"}>
                                                    <thead>
                                                        <tr className="tbr">
                                                            <th className="font-weight-bold text-white" colSpan="5">Debtors Account (lena hai)</th>
                                                        </tr>
                                                        <tr className="headings plusacc">
                                                            <th className="font-weight-bold width-150">Account</th>
                                                            <th className="font-weight-bold width-100 text-right">Client(P/L)</th>
                                                            <th className="font-weight-bold width-130" colSpan="2">Settle Amount</th>
                                                            <th className="font-weight-bold usett-200">Remarks</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {!!this.state.settlementData && this.state.settlementData.map((settlement, i) => {
                                                            return (<>
                                                                {settlement.current_pnl <= -1 &&
                                                                    <tr className={this.state.typeUserPnl.length > 0 ? this.state.typeUserPnl.includes(settlement.username) ? "error-alert plusacc" : "plusacc" : "plusacc"}>
                                                                        <td className="width-150" style={{ verticalAlign: "middle" }}><div className="res"><span className={settlement.role === "SuperMaster" || settlement.role === "SubSuperMaster" ? "client-icon-sm" : "client-icon"}><img src={BASE_IMAGE_PATH + "/aimg/" + settlement.role + "-icon.svg"} alt="" /></span>{settlement.username} </div></td>
                                                                        <td className="width-100 red text-right res" style={{ verticalAlign: "middle" }}>{!!settlement.current_pnl ? <Currency amount={settlement.current_pnl} showColor={true} /> : "0"}</td>
                                                                        <td className="red width-130">
                                                                            <div className="d-flex res">
                                                                                <input type="number" name="pnl" value={settlement.pnl} onChange={(e) => { this.onAmountChange(e, i, settlement) }} className="form-control mobilewidth" placeholder="" />
                                                                            </div>
                                                                        </td>
                                                                        <td className="width-80 mx-auto"><div className="res1"><button className="btn btn-red btn-sm ml-1 float-right" onClick={(e) => { e.target.name = "pnl"; e.target.value = settlement.current_pnl; this.onAmountChange(e, i) }}>Full Settle</button></div></td>
                                                                        <td className="width-90">
                                                                            <input type="text" name="description" value={settlement.description} onChange={(e) => { this.onAmountChange(e, i, settlement) }} className="form-control w-100 mobilewidth" placeholder="Remarks" />
                                                                        </td>
                                                                    </tr>
                                                                }
                                                            </>)
                                                        })}
                                                        {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid footer1">
                    <div className="row">
                        <div className="col mobile-user-footer">
                            <div className="text-center">
                                <input type="text" className="form-control w-25 d-inline mr-1" placeholder="Remarks" name="allRemarks" value={this.state.allRemarks} onChange={(e) => { this.onChange(e) }} />
                                <button type="button" className="btn btn-primary btn-sm mr-1" onClick={(e) => { this.onSettleAll() }}>Fill All</button>
                            </div>
                            <div className="text-center">
                                <div className="d-inline">
                                    <input type="Password" className="form-control w-25 d-inline" onKeyUp={(e) => { this.handleKey(e) }} placeholder="Password" name="masterPassword" value={this.state.masterPassword} onChange={(e) => { this.onChange(e) }} />
                                    <button type="button" className="btn btn-primary btn-sm ml-1" onClick={(e) => { this.onSubmit() }}>Submit</button>
                                    <button type="button" className="btn btn-primary btn-sm mr-1" onClick={(e) => { this.onSettleClear() }}>Clear All</button>
                                </div>
                            </div>
                        </div>
                        <div className="col desktop-user-footer">
                            <div className="text-center">
                                <input type="text" className="form-control w-25 d-inline mr-1" placeholder="Remarks" name="allRemarks" value={this.state.allRemarks} onChange={(e) => { this.onChange(e) }} />
                                <button type="button" className="btn btn-primary btn-sm mr-1" onClick={(e) => { this.onSettleAll() }}>Fill All</button>
                                <div className="d-inline">
                                    <input type="Password" className="form-control w-25 d-inline" onKeyUp={(e) => { this.handleKey(e) }} placeholder="Password" name="masterPassword" value={this.state.masterPassword} onChange={(e) => { this.onChange(e) }} />
                                    <button type="button" className="btn btn-primary btn-sm ml-1" onClick={(e) => { this.onSubmit() }}>Submit</button>
                                    <button type="button" className="btn btn-primary btn-sm ml-1" onClick={(e) => { this.onSettleClear() }}>Clear All</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(MasterSettlement);